module.exports = __webpack_public_path__ + "static/home-store.c185f61d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-store.png
// module id = 590
// module chunks = 35783957827783